import { useState } from "react";
import SimpleMdeReact from "react-simplemde-editor";
import { Col, Input, Label, Modal, ModalBody, ModalFooter } from "reactstrap";
import { Btn, H4, P } from "../../../../../../AbstractElements";
import { Add, Cancel, CategoryName, CreateNewCategoryHeading, Href, MdeEditorText } from "../../../../../../Constants/Constants";

const CreateNewCategory = () => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  return (
    <Col xs="12">
      <div className="category-buton">
        <Btn color="transparent" tag="a" className="button-primary bg-light-primary font-primary" href={Href} onClick={toggle}>
          <i className="me-2 fa fa-plus"> </i>{CreateNewCategoryHeading}
        </Btn>
      </div>
      <Modal isOpen={modal} toggle={toggle} size="lg" >
        <div className="modal-header">
          <H4 className="modal-title fs-5">{CreateNewCategoryHeading}</H4>
          <Btn close onClick={toggle} />
        </div>
        <ModalBody className="custom-input">
          <div className="create-category">
            <Label for="validationServer01">{CategoryName} <span className="text-danger"> *</span></Label>
            <Input className="m-0" id="validationServer01" type="text" required />
            <div id="editor3" className="mt-2">
              <SimpleMdeReact id="editor_container" placeholder={MdeEditorText} options={{ autofocus: true, spellChecker: false }} />
            </div>
            <P className="f-light">Improve product visibility by adding a compelling description.</P>
          </div>
        </ModalBody>
        <ModalFooter>
          <Btn color="light" className="font-dark" onClick={toggle}> {Cancel}</Btn>
          <Btn color="primary" onClick={toggle}> {Add}</Btn>
        </ModalFooter>
      </Modal>
    </Col>
  );
};

export default CreateNewCategory;
